@if (isChecking) {
  <div class="login-checking" data-testid="login-loading">
    <div class="login-checking__spinner"></div>
  </div>
} @else {
  <div class="login-shell">
    <div class="login-card" role="region" [attr.aria-label]="T.login.signInHeading" data-testid="login-card">
      <header class="login-card__top">
        <img
          src="assets/images/OmniFlow-Logo.png"
          class="login-card__logo"
          [alt]="T.common.appName"
          data-testid="login-logo"
        />
        <img
          src="assets/images/assurant-logo.svg"
          class="login-card__partner"
          [alt]="T.login.brandPartner"
          data-testid="login-partner-logo"
        />
      </header>

      <div class="login-card__body">
        <h1 class="login-card__heading" data-testid="login-title">
          {{ T.login.headlineLine1 }}<br />{{ T.login.headlineLine2 }}
        </h1>
        <p class="login-card__subtitle" data-testid="login-subtitle">
          {{ T.login.subtitle }}
        </p>

        <ul class="login-card__bullets">
          @for (bullet of T.login.bullets; track bullet) {
            <li [attr.data-testid]="'login-bullet-' + bullet">
              <span class="login-card__dot" aria-hidden="true"></span>
              {{ bullet }}
            </li>
          }
        </ul>
      </div>

      <button type="button" class="login-card__submit" (click)="onSubmit()" data-testid="login-submit-button">
        {{ T.login.signInButton }}
      </button>
    </div>
  </div>
}
